
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.1002 12.08C9.10015 8.20001 10.1802 4.72001 11.1702 2.81001C11.3602 2.45001 11.0502 2.04001 10.6402 2.09001C5.62015 2.77001 1.78015 7.16001 1.99015 12.41C2.00015 12.41 2.00015 12.41 2.00015 12.42C2.62015 12.15 3.29015 12 4.00015 12C5.66015 12 7.18015 12.83 8.10015 14.15C9.77015 14.63 11.0002 16.17 11.0002 18C11.0002 19.52 10.1302 20.83 8.88015 21.51C9.86015 21.83 10.9102 22.01 11.9902 22.01C15.1202 22.01 17.9102 20.57 19.7502 18.32C20.0102 18 19.7901 17.53 19.3801 17.5C16.8902 17.37 13.1002 15.97 11.1002 12.08Z' fill='#323232'/><path d='M7 16H6.82C6.4 14.84 5.3 14 4 14C2.34 14 1 15.34 1 17C1 18.66 2.34 20 4 20C4.62 20 6.49 20 7 20C8.1 20 9 19.1 9 18C9 16.9 8.1 16 7 16Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-nights-stay`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNightsStay

    ```js
    <b-new-b-icon-nights-stay />
    ```
</docs>


